import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class New extends React.PureComponent {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    pin: PropTypes.object,
    onDone: PropTypes.func
  }

  state = {
    config: {}
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { pin } = this.props
    return {
      title: 't(Edit Pin)',
      color: 'pink',
      cancelSvg: 'chevron_left',
      onCancel: this._handleCancel,
      onSubmit: this._handleSubmit,
      sections: [
        {
          fields: [
            { label: 't(Address)', name: 'address', type: 'addressfield', required: true, defaultValue: pin.address },
            { label: 't(Title)', name: 'title', type: 'textfield', required: true, defaultValue: pin.title },
            { label: 't(Description)', name: 'description', type: 'textfield', defaultValue: pin.description }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.form.pop()
  }

  _handleSubmit(pin) {
    this.props.onDone(pin)
    this.context.form.pop()
  }

}

export default New
